import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { heroSlides } from "@/mocks/movies";

export default function HeroCarousel() {
  const [active, setActive] = useState(0);
  const navigate = useNavigate();
  const total = heroSlides.length;
  const current = heroSlides[active];

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((index) => (index + 1) % total);
    }, 5500);
    return () => clearInterval(timer);
  }, [total]);

  const goTo = (direction: number) => {
    setActive((index) => (index + direction + total) % total);
  };

  return (
    <section className="relative w-full h-[440px] md:h-[600px] overflow-hidden bg-foreground-950">
      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ease-out ${
            index === active ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 焦点图`}
            title={slide.title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/55 to-black/20" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
        </div>
      ))}

      <div className="relative z-10 h-full w-full max-w-[1400px] mx-auto px-4 md:px-6 flex flex-col justify-end md:justify-center pb-16 md:pb-0">
        <div key={current.id} className="max-w-2xl animate-fade-up">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-bold tracking-wide">
            {current.tag}
          </span>
          <h1 className="mt-4 font-heading text-3xl md:text-5xl font-black text-background-50 leading-tight">
            {current.title}
          </h1>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-background-100/90 leading-relaxed max-w-xl">
            {current.subtitle}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={() => navigate(`/detail/${current.id}`)}
              className="px-6 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
            >
              <i className="ri-play-fill mr-1"></i>立即观看
            </button>
            <button
              type="button"
              onClick={() => navigate(`/detail/${current.id}`)}
              className="px-6 py-2.5 rounded-md bg-background-50/15 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-background-50/25 border border-background-50/30 transition-colors"
            >
              查看详情
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        aria-label="上一张"
        onClick={() => goTo(-1)}
        className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-black/35 text-background-50 hover:bg-black/55 cursor-pointer transition-colors"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        type="button"
        aria-label="下一张"
        onClick={() => goTo(1)}
        className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-20 w-10 h-10 items-center justify-center rounded-full bg-black/35 text-background-50 hover:bg-black/55 cursor-pointer transition-colors"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 md:bottom-7 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {heroSlides.map((slide, index) => (
          <button
            key={slide.id}
            type="button"
            aria-label={`切换到第${index + 1}张`}
            onClick={() => setActive(index)}
            className={`h-1.5 rounded-full cursor-pointer transition-all ${
              index === active ? "w-8 bg-primary-500" : "w-3 bg-background-50/50"
            }`}
          />
        ))}
      </div>
    </section>
  );
}